import React from 'react'
import Footer from '../components/footerComponent/footer'
import Header from '../components/headerComponent/header'
import {Layout} from 'antd';
import AddLesson from '../components/teacherComponent/addLessonComponent';

export default function AddLessonPage() {
    return (
        <Layout>
            <Header/>
            <AddLesson/>
            <Footer/>
        </Layout>
    );
};